export default __webpack_public_path__ + "static/screenshot4-947e8a6aefd7d1006cdb0b7cd444b8ca.jpg";